import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, byteSize, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './announcement.reducer';

export const AnnouncementDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const announcementEntity = useAppSelector(state => state.announcement.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="announcementDetailsHeading">
          <Translate contentKey="fivePlusApp.announcement.detail.title">Announcement</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{announcementEntity.id}</dd>
          <dt>
            <span id="imageName">
              <Translate contentKey="fivePlusApp.announcement.imageName">Image Name</Translate>
            </span>
          </dt>
          <dd>{announcementEntity.imageName}</dd>
          <dt>
            <span id="topics">
              <Translate contentKey="fivePlusApp.announcement.topics">Topics</Translate>
            </span>
          </dt>
          <dd>{announcementEntity.topics}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fivePlusApp.announcement.description">Description</Translate>
            </span>
          </dt>
          <dd>{announcementEntity.description}</dd>
          <dt>
            <span id="link">
              <Translate contentKey="fivePlusApp.announcement.link">Link</Translate>
            </span>
          </dt>
          <dd>{announcementEntity.link}</dd>
          <dt>
            <span id="createdDate">
              <Translate contentKey="fivePlusApp.announcement.createdDate">Created Date</Translate>
            </span>
          </dt>
          <dd>
            {announcementEntity.createdDate ? (
              <TextFormat value={announcementEntity.createdDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="modifiedDate">
              <Translate contentKey="fivePlusApp.announcement.modifiedDate">Modified Date</Translate>
            </span>
          </dt>
          <dd>
            {announcementEntity.modifiedDate ? (
              <TextFormat value={announcementEntity.modifiedDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="fivePlusApp.announcement.user">User</Translate>
          </dt>
          <dd>{announcementEntity.user ? announcementEntity.user.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/announcement" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/announcement/${announcementEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AnnouncementDetail;
